import { excelStore } from "src/stores/excel-store.interface";
import InformationTable from "./components/InformationTable";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";

const WWTSetupInformation = () => {
  const currentYear = new Date().getFullYear();
  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));

  useEffect(() => {
    return () => {
      setSelectedYearExcel(currentYear.toString());
    };
  }, []);
  return <InformationTable />;
};

export default WWTSetupInformation;
